// extracted by mini-css-extract-plugin
export var adminLinkTag = "_a-1q";
export var assigneePill = "_a-2m";
export var assigneesList = "_a-2l";
export var automationCard = "_a-50";
export var automationDetails = "_a-52";
export var automationLabel = "_a-54";
export var automationList = "_a-4z";
export var automationNotConfigured = "_a-56";
export var automationRow = "_a-53";
export var automationTitle = "_a-51";
export var automationValue = "_a-55";
export var backButton = "_a-1n";
export var cancelButton = "_a-24";
export var cardLabel = "_a-4h";
export var cardValue = "_a-4i";
export var configActions = "_a-6s";
export var configAssignee = "_a-5t";
export var configAssigneeDept = "_a-5v";
export var configAssigneeName = "_a-5u";
export var configAssignees = "_a-5s";
export var configContent = "_a-5f";
export var configDeactivateButton = "_a-6t";
export var configDeleteButton = "_a-6u";
export var configEmpty = "_a-5e";
export var configHeader = "_a-5g";
export var configLabel = "_a-5l";
export var configLabelWithIcon = "_a-5m";
export var configLoading = "_a-5d";
export var configNotes = "_a-5w";
export var configRow = "_a-5k";
export var configSection = "_a-5i";
export var configSectionTitle = "_a-5j";
export var configStatusCard = "_a-5p";
export var configStatusRow = "_a-5o";
export var configStep = "_a-5y";
export var configStepCount = "_a-61";
export var configStepHeader = "_a-5z";
export var configStepName = "_a-60";
export var configStepSkipped = "_a-65";
export var configStepSkippedBadge = "_a-66";
export var configStepsList = "_a-5x";
export var configSubstep = "_a-63";
export var configSubstepSkipped = "_a-64";
export var configSubsteps = "_a-62";
export var configValue = "_a-5n";
export var confirmButton = "_a-25";
export var contentGrid = "_a-37";
export var contentLoading = "_a-1j";
export var coverageDetails = "_a-4k";
export var coverageSection = "_a-4j";
export var dealSizeField = "_a-2g";
export var dealSizeInput = "_a-2f";
export var dealSizeSaveButton = "_a-2h";
export var deleteModal = "_a-6v";
export var detailPanelsContainer = "_a-2j";
export var detailsGrid = "_a-i";
export var dollarSign = "_a-2e";
export var editButton = "_a-2i";
export var editConfigButton = "_a-5h";
export var emptyState = "_a-j";
export var emptyStateText = "_a-l";
export var emptyStateTitle = "_a-k";
export var emptyText = "_a-4d";
export var errorContainer = "_a-1i";
export var expandButton = "_a-3e";
export var gridCard = "_a-4g";
export var headerActions = "_a-1v";
export var headerTags = "_a-1p";
export var hubspotLink = "_a-5q";
export var hubspotLinkTag = "_a-1t";
export var hubspotLinkText = "_a-5r";
export var infoCard = "_a-4c";
export var kpiDivider = "_a-2d";
export var kpiItem = "_a-29";
export var kpiLabel = "_a-2a";
export var kpiRow = "_a-27";
export var kpiSpacer = "_a-28";
export var kpiValue = "_a-2c";
export var kpiValueContainer = "_a-2b";
export var leftColumn = "_a-38";
export var loadMoreButton = "_a-36";
export var loadMoreContainer = "_a-35";
export var loadingContainer = "_a-1h";
export var loadingIcon = "_a-1k";
export var loadingIconSmall = "_a-5c";
export var metaSection = "_a-1m";
export var notStartedTag = "_a-1r";
export var notePill = "_a-47";
export var notePillHeader = "_a-48";
export var notePillStep = "_a-49";
export var notePillText = "_a-4b";
export var notePillTimestamp = "_a-4a";
export var notesGrid = "_a-46";
export var oeConfigLabel = "_a-69";
export var oeConfigRow = "_a-68";
export var oeConfigValue = "_a-6a";
export var oeEditWindowGroup = "_a-67";
export var oePlatformsList = "_a-6n";
export var oeProgressBadge = "_a-6o";
export var oeStepItem = "_a-6q";
export var oeStepItemCompleted = "_a-6r";
export var oeStepsList = "_a-6p";
export var oeSubOption = "_a-6j";
export var oeSubOptionActive = "_a-6k";
export var oeSubOptionDot = "_a-6m";
export var oeSubOptionIcon = "_a-6l";
export var oeSubOptions = "_a-6i";
export var oeToolDuration = "_a-6g";
export var oeToolHeader = "_a-6e";
export var oeToolItem = "_a-6c";
export var oeToolItemEnabled = "_a-6d";
export var oeToolName = "_a-6f";
export var oeToolToggle = "_a-6h";
export var oeToolsList = "_a-6b";
export var pageContainer = "_a-1g";
export var pageTitle = "_a-1o";
export var pageWrapper = "_a-0";
export var paymentCard = "_a-4q";
export var paymentLabel = "_a-4s";
export var paymentRow = "_a-4r";
export var paymentValue = "_a-4t";
export var portalCard = "_a-4u";
export var portalLabel = "_a-4w";
export var portalLogo = "_a-4y";
export var portalRow = "_a-4v";
export var portalValue = "_a-4x";
export var preInstallBadge = "_a-1s";
export var productNavBar = "_a-3";
export var productStatusDot = "_a-6";
export var productStatusDotComplete = "_a-7";
export var productStatusDotHelpRequested = "_a-b";
export var productStatusDotInProgress = "_a-8";
export var productStatusDotNotStarted = "_a-a";
export var productStatusDotReopened = "_a-9";
export var productTab = "_a-4";
export var productTabActive = "_a-5";
export var progressBar = "_a-3l";
export var progressBarFill = "_a-3m";
export var progressCard = "_a-3f";
export var progressCircle = "_a-o";
export var progressCircleBg = "_a-p";
export var progressCircleFill = "_a-q";
export var progressCircleText = "_a-r";
export var progressLabel = "_a-3h";
export var progressMeta = "_a-3g";
export var progressPercent = "_a-3n";
export var progressStats = "_a-3i";
export var progressSubvalue = "_a-3k";
export var progressSummary = "_a-m";
export var progressSummaryDetail = "_a-v";
export var progressSummaryInfo = "_a-s";
export var progressSummaryMain = "_a-n";
export var progressSummarySubtitle = "_a-u";
export var progressSummaryTitle = "_a-t";
export var progressValue = "_a-3j";
export var pushActions = "_a-20";
export var pushButton = "_a-1x";
export var pushButtonContainer = "_a-1w";
export var pushButtonSuccess = "_a-1z";
export var pushDateInfo = "_a-2p";
export var pushDateText = "_a-1y";
export var pushToggle = "_a-22";
export var pushTogglesContainer = "_a-21";
export var pushWarning = "_a-2n";
export var pushWarningPill = "_a-2o";
export var replayLinkTag = "_a-1u";
export var returnFlowCard = "_a-57";
export var returnFlowStat = "_a-59";
export var returnFlowStatLabel = "_a-5a";
export var returnFlowStatValue = "_a-5b";
export var returnFlowSummary = "_a-58";
export var rightColumn = "_a-39";
export var section = "_a-3a";
export var sectionCheckbox = "_a-3d";
export var sectionHeader = "_a-3b";
export var sectionTitle = "_a-3c";
export var selectAllButton = "_a-23";
export var sessionBadge = "_a-26";
export var sessionButton = "_a-34";
export var sessionDate = "_a-2z";
export var sessionInfo = "_a-2x";
export var sessionItem = "_a-2v";
export var sessionItemActive = "_a-2w";
export var sessionMeta = "_a-30";
export var sessionMetaItem = "_a-31";
export var sessionMetaLabel = "_a-32";
export var sessionMetaValue = "_a-33";
export var sessionTitle = "_a-2y";
export var sessionsButton = "_a-2k";
export var sessionsContainer = "_a-2q";
export var sessionsEmpty = "_a-2t";
export var sessionsHeader = "_a-2r";
export var sessionsList = "_a-2u";
export var sessionsLoading = "_a-2s";
export var spin = "_a-1l";
export var stepCard = "_a-x";
export var stepCardCircle = "_a-12";
export var stepCardCircleComplete = "_a-14";
export var stepCardCirclePartial = "_a-13";
export var stepCardComplete = "_a-y";
export var stepCardCount = "_a-16";
export var stepCardHeader = "_a-10";
export var stepCardPartial = "_a-z";
export var stepCardStatus = "_a-11";
export var stepCardSubsteps = "_a-17";
export var stepCardTitle = "_a-15";
export var stepDuration = "_a-3v";
export var stepHeader = "_a-3t";
export var stepItem = "_a-3p";
export var stepItemCompleted = "_a-3q";
export var stepItemExpanded = "_a-3s";
export var stepItemPartial = "_a-3r";
export var stepName = "_a-3u";
export var stepToggle = "_a-3w";
export var stepToggleOpen = "_a-3y";
export var stepTogglePlaceholder = "_a-3x";
export var stepsGrid = "_a-w";
export var stepsList = "_a-3o";
export var substepBullet = "_a-44";
export var substepCompleted = "_a-41";
export var substepDuration = "_a-45";
export var substepIcon = "_a-43";
export var substepItem = "_a-40";
export var substepName = "_a-42";
export var substepRow = "_a-18";
export var substepRowComplete = "_a-19";
export var substepRowDot = "_a-1b";
export var substepRowIcon = "_a-1a";
export var substepRowName = "_a-1c";
export var substepRowTime = "_a-1d";
export var substepsList = "_a-3z";
export var tab = "_a-f";
export var tabActive = "_a-g";
export var tabBar = "_a-e";
export var tabBarContainer = "_a-c";
export var tabBarContent = "_a-d";
export var tabContent = "_a-h";
export var tag = "_a-4o";
export var tagEmpty = "_a-4p";
export var tagLabel = "_a-4m";
export var tagList = "_a-4n";
export var tagSection = "_a-4l";
export var threeColGrid = "_a-4f";
export var topHeader = "_a-1";
export var topHeaderContent = "_a-2";
export var topHeaderLeft = "_a-1f";
export var topHeaderMain = "_a-1e";
export var twoColGrid = "_a-4e";